module.exports = __webpack_public_path__ + "media/application/images/playbook-green-card-bg-585bb49abf6279eacf73d280665cc2ab.png";